(function () {
	let swiperMulticolumn;

	const positionDots = (swiper, paginationEl) => {
		if (!paginationEl || !swiper) return;
		requestAnimationFrame(() => {
			const activeSlide = swiper.slides[swiper.activeIndex];
			const imageWrapper = activeSlide && activeSlide.querySelector(".multicolumn-card__image-wrapper");
			if (imageWrapper) {
				const swiperBottom = swiper.el.getBoundingClientRect().bottom;
				const imageBottom = imageWrapper.getBoundingClientRect().bottom;
				paginationEl.style.bottom = (swiperBottom - imageBottom + 16) + "px";
			} else {
				paginationEl.style.bottom = "80px";
			}
		});
	};

	const buildDots = (swiper, paginationEl) => {
		if (!paginationEl) return;
		paginationEl.innerHTML = "";
		swiper.slides.forEach((_, i) => {
			const isActive = i === swiper.activeIndex;
			const bullet = document.createElement("span");
			bullet.className = "swiper-pagination-bullet" + (isActive ? " swiper-pagination-bullet-active" : "");
			bullet.style.cssText = `
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				background: #eeff41;
				opacity: ${isActive ? "1" : "0.35"};
				cursor: pointer;
				flex-shrink: 0;
			`;
			bullet.addEventListener("click", () => swiper.slideTo(i));
			paginationEl.appendChild(bullet);
		});
		positionDots(swiper, paginationEl);
	};

	const initSlider = (sectionId, paginationEl) => {
		if (swiperMulticolumn) return;

		const slides = document.querySelectorAll(`#${sectionId} .multicolumn-list__item`);
		slides.forEach((slide) => slide.classList.add("swiper-slide"));

		swiperMulticolumn = new Swiper(`#${sectionId} .swiper--multicolumn`, {
			loop: false,
			speed: 1100,
			on: {
				slideChange() { buildDots(this, paginationEl); },
			},
		});
		buildDots(swiperMulticolumn, paginationEl);
	};

	const destroySlider = (sectionId) => {
		const slides = document.querySelectorAll(`#${sectionId} .multicolumn-list__item`);

		swiperMulticolumn.destroy(true, true);
		swiperMulticolumn = undefined;

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector(".multicolumn-section");
		if (!multicolumnSection) return;

		const sectionId = multicolumnSection.id;
		const multicolumnSwipeEnabled = multicolumnSection.querySelector(".swiper--multicolumn");
		const paginationEl = document.querySelector(`#${sectionId} .multicolumn-pagination`);

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 990 && multicolumnSwipeEnabled) {
				initSlider(sectionId, paginationEl);
				if (swiperMulticolumn) positionDots(swiperMulticolumn, paginationEl);
			} else if (swiperMulticolumn) {
				destroySlider(sectionId);
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperMulticolumn) {
		swiperMulticolumn.destroy(true, true);
		swiperMulticolumn = undefined;
	}
	initMulticolumn();
	document.addEventListener("shopify:section:load", function () {
		if (swiperMulticolumn) {
			swiperMulticolumn.destroy(true, true);
			swiperMulticolumn = undefined;
		}
		initMulticolumn();
	});
})();
